"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9120,405,7890],{

/***/ 405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8996);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47322);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);







function Eyebrow(_ref) {
  var children = _ref.children,
      Tag = _ref.tag,
      id = _ref.id,
      className = _ref.className,
      styles = _ref.styles,
      whiteText = _ref.whiteText,
      blueEyebrow = _ref.blueEyebrow;

  if (!children) {
    return null;
  }

  var isStringChildren = (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(children);
  var isObjectChildren = (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_2__/* .isObject */ .Kn)(children);
  className = className ? "ob-eyebrow ".concat(className) : 'ob-eyebrow';

  var renderChildren = function renderChildren() {
    try {
      if (typeof children.map == 'undefined') {
        return children;
      } else {
        return children.map(function (child) {
          return child;
        });
      }
    } catch (_unused) {
      console.log('Eyebrow error', children);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
    fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_3__["default"], {}),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Tag, {
      id: id,
      className: className,
      "data-white-text": whiteText,
      "data-blue-text": blueEyebrow,
      style: styles,
      children: isObjectChildren ? renderChildren() : isStringChildren ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
        dangerouslySetInnerHTML: {
          __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_4___default().sanitize(children)
        }
      }) : ''
    })
  });
}

Eyebrow.defaultProps = {
  tag: 'p',
  className: '',
  styles: {},
  whiteText: false
};
/* harmony default export */ __webpack_exports__["default"] = (Eyebrow);

/***/ })

}]);